import { render, staticRenderFns } from "./MultiFileComponent.vue?vue&type=template&id=237a2c1c&scoped=true"
import script from "./MultiFileComponent.vue?vue&type=script&lang=js"
export * from "./MultiFileComponent.vue?vue&type=script&lang=js"
import style0 from "./MultiFileComponent.vue?vue&type=style&index=0&id=237a2c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a2c1c",
  null
  
)

export default component.exports